import { useLanguage } from 'providers/Language';
import { useSelector } from 'react-redux';

// used for browser tab (document title) and acessible h1
export default function useGeneratedTitle(): string {
  const { title, name } = useSelector((state: AppState) => ({
    title: state.appData.title,
    name: state.appData.name,
  }));

  const { t } = useLanguage();

  return (() => {
    let currentGeneratedTitle = t('pageDefaultTitle');
    if (title && name) {
      currentGeneratedTitle = `${name} - ${title} | ${t('pageDefaultTitle')}`;
    }
    return currentGeneratedTitle;
  })();
}
